module.exports = __webpack_public_path__ + "0e480ace46418ec971db9fecb018ebc5.pdf";